import { useEffect, useState } from "react";

export function TourCursor({
  x,
  y,
  reducedMotion,
}: {
  x: number;
  y: number;
  reducedMotion: boolean;
}) {
  // Trigger a ripple shortly after the cursor arrives at a new target
  const [rippleKey, setRippleKey] = useState(0);
  useEffect(() => {
    const t = window.setTimeout(() => setRippleKey((k) => k + 1), reducedMotion ? 0 : 650);
    return () => window.clearTimeout(t);
  }, [x, y, reducedMotion]);

  const transition = reducedMotion
    ? "none"
    : "transform 700ms cubic-bezier(0.4, 0, 0.2, 1)";

  return (
    <div
      className="tour-cursor"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        transform: `translate3d(${x}px, ${y}px, 0)`,
        transition,
        zIndex: 9200,
        pointerEvents: "none",
        willChange: "transform",
      }}
      aria-hidden="true"
    >
      <svg width="28" height="28" viewBox="0 0 28 28" style={{ display: "block" }}>
        <defs>
          <filter id="tour-cursor-shadow" x="-50%" y="-50%" width="200%" height="200%">
            <feDropShadow dx="0" dy="2" stdDeviation="2.5" floodColor="rgba(0,0,0,0.6)" />
          </filter>
        </defs>
        <path
          d="M5 3 L5 22 L10 17 L13 24 L16.5 22.5 L13.5 15.5 L20 15.5 Z"
          fill="#f0eee9"
          stroke="#0d0c0a"
          strokeWidth="1.2"
          strokeLinejoin="round"
          filter="url(#tour-cursor-shadow)"
        />
      </svg>
      <span key={rippleKey} className="tour-cursor-ripple" />
    </div>
  );
}
